<template lang='pug'>
  div
    //Button link
    app-icon-btn(
      :disabled="this.disabled"
      @click.native="showModal",
      data-kind="link",
      data-icon="fa-solid fa-calendar-days",
      :data-label="$I18n.t('vue.order_schedule.title')"
    )
    app-modal(
      :showing="controls.modal.showing",
      @showing="controls.modal.showing = $event"
    )
      template(#header)
        p {{ labels.modal_title }}
      template(#body)
        // Spinner Loading
        div(v-if="state.sending" class="tw-text-center tw-my-20")
          div(class="spinner-border spinner-border-sm" role="status")

        // FORM
        div(v-else)
          app-form.tw-py-4(v-bind:grid="formGrid")
      template(#footer)
        .app-buttons-row.justify-end(v-if="!state.sending")
          app-icon-btn(
            data-kind="link",
            @click.native="clear",
            data-icon="fa-solid fa-eraser",
            :data-label="labels.clear_btn"
          )
          app-icon-btn(
            data-kind="link",
            @click.native="cancel",
            data-icon="fa-solid fa-square-xmark",
            :data-label="labels.cancel_btn"
          )
          app-icon-btn(
            data-kind="btn",
            @click.native="send",
            data-icon="fa-solid fa-floppy-disk",
            :data-label="labels.send_btn"
          )
</template>

<script>
import { ActiveValue } from "../../core/active_support";
import CoreComponents from "../core";
import BackendService from '../../services/backend_service';
const { ActiveValuesMixin, ProcessingMixin } = require("../../mixins");

export default {
  mixins: [ActiveValuesMixin, ProcessingMixin],
  components: {
    "app-icon-btn": CoreComponents.AppIconBtn,
    "app-modal": CoreComponents.Modal,
    "app-form": CoreComponents.Detailform,
  },
  props:['dataOrder', 'disabled'],
  data: function () {
    return {
      record: {
        order: this.dataOrder
      },
      controls: {
        modal: {
          showing: false,
        },
      },
      state:{
        sending: false
      },
      labels: {
        modal_title: this.$I18n.t('vue.order_schedule.title'),
        clear_btn: this.$I18n.t('vue.order_schedule.clear'),
        cancel_btn: this.$I18n.t('vue.order_schedule.cancel'),
        send_btn: this.$I18n.t('vue.order_schedule.send'),
      },
      values: {
        schedule_for: ActiveValue().setup((i) => {
          i.setLabel(this.$I18n.t('vue.order_schedule.date'));
          i.setValue(this.dataOrder.schedule_for);
          i.setInputKind("date");
          i.required();
        })
      },
      
    };
  },
  computed: {
    formGrid: function () {
      return [
        [this.values.schedule_for]
      ];
    },
  },
  methods: {
    showModal: function () {
      this.controls.modal.showing = true;
    },
    hideModal: function () {
      this.controls.modal.showing = false;
    },
    clear: function () {
      this.resetActiveValues(this.values);
    },
    cancel: function () {
      this.hideModal();
      this.resetActiveValues(this.values);
    },
    disabled_inputs: function () {
      
    },
    send_params: function () {
      let params = JSON.stringify({
        id: this.record.order.id,
        schedule_for: this.values.schedule_for.input
      });
      return params;
    },
    send: function () {
      let self = this;
      if (this.areValidActiveValues(this.values)) {
        let params = this.send_params()
        self.state.sending = true;
        BackendService
          .order_update_schedule_for(params)
          .then(_=>{
            this.clear();
            //this.hideModal();
            location.reload();
          })
      }
    },
  },
};
</script>
